import React, { useState } from 'react';
import './SessionIdModal.css';
import { useCollab } from '../../contexts/CollabContext';
import { Mode } from 'types/modes';

interface SessionIdModalProps {
  onSubmit: (sessionId: string) => void;
  onClose: () => void;
}

const SessionIdModal: React.FC<SessionIdModalProps> = ({ onSubmit, onClose }) => {
  
  const collab = useCollab();

  // INPUT FIELDS
  const [sessionId, setSessionId] = useState('');
  //
  
  // PRIVATE 
  const [error, setError] = useState<string|null>(null);
  //

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!sessionId.trim()) {
      setError('Session ID is required');
      return;
    }
    
    setError(null);
    onSubmit(sessionId.trim());
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Join Session</h3>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label htmlFor="sessionId">Session ID</label>
              <input
                type="text"
                id="sessionId"
                value={sessionId}
                onChange={(e) => setSessionId(e.target.value)}
                placeholder="Enter session ID"
                className={error && !sessionId.trim() ? 'error' : ''}
              />
            </div>
            {error && <div className="error-message">{error}</div>}
            {collab.collabErrors[Mode.Join] && (
                <div className="error-message">{collab.collabErrors[Mode.Join]}</div>
            )}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn-primary">
              Join Session
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SessionIdModal; 